export default [
  'CbpResourceRepositoryFactory',
  function (CbpResourceRepositoryFactory) {
    return new CbpResourceRepositoryFactory('/sid/issuer/sid-requests/{requestId}/sid-response-forwards');
  },
];
